import { Checkbox, TextField } from "components";
import formatDate from "utils/formatDate";
import { isValidDate } from "utils/validDate";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { useEffect, useState } from "react";
import moment from "moment";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const TransferMoveSaleDate = () => {
	const [error, setError] = useState(false);
	const {
		next,
		transferMoveOutDate,
		setTransferMoveOutDate,
		transferSaleDate,
		setTransferSaleDate,
		transferOwnerDidNotSellProperty,
		setTransferOwnerDidNotSellProperty,
		previousAddressValue,
	} = useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		trackEvent({
			eventName:
				constants.EVENTS.Exemptions_Flow_Transfer_Move_Sell_Dates_Action,
			data: {
				"Transfer Move Out Date": transferMoveOutDate,
				"Transfer Sale Date": transferOwnerDidNotSellProperty
					? "Did Not Sell"
					: transferSaleDate,
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Transfer Move Out Date": transferMoveOutDate,
			"Transfer Sale Date": transferOwnerDidNotSellProperty
				? "Did Not Sell"
				: transferSaleDate,
		};
		next({ trackingEventData });
	};

	useEffect(() => {
		if (transferMoveOutDate?.length !== 10 || transferSaleDate?.length !== 10)
			return;
		const purchaseDateError =
			moment(transferMoveOutDate).isAfter(moment()) ||
			moment(transferSaleDate).isAfter(moment());

		setError(purchaseDateError);
	}, [transferMoveOutDate, transferSaleDate]);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>
						Move Out and Sale Date of{" "}
						{previousAddressValue ?? "your previous homestead address"}
					</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					This helps us tell the county which address your previous homestead
					should be transferred from.
				</p>
				<div className="exemptions-input-flex-container">
					<TextField
						required
						label="Move out Date"
						placeholder="MM/DD/YYYY"
						containerClassName="exemptions-card-input"
						maxLength={10}
						minLength={10}
						value={transferMoveOutDate ?? ""}
						onChange={e => {
							const formatted = formatDate(e, transferMoveOutDate ?? "");
							const valid = isValidDate(formatted);

							if (valid) {
								setTransferMoveOutDate(formatted);
							}
						}}
					/>
					<div className="exemptions-card-input">
						<TextField
							label="Sale Date"
							placeholder="MM/DD/YYYY"
							containerClassName=""
							maxLength={10}
							minLength={10}
							value={transferSaleDate ?? ""}
							onChange={e => {
								const formatted = formatDate(e, transferSaleDate ?? "");
								const valid = isValidDate(formatted);

								if (valid) {
									setTransferSaleDate(formatted);
								}
							}}
						/>
						<Checkbox
							name="transferOwnerDidNotSellProperty"
							label="I did not sell this property"
							labelEl="p"
							onChange={() => {
								setTransferOwnerDidNotSellProperty(
									!transferOwnerDidNotSellProperty
								);
							}}
							checked={transferOwnerDidNotSellProperty}
						/>
					</div>
				</div>
			</div>
			<ButtonV2
				size="large"
				disabled={
					transferMoveOutDate?.length !== 10 ||
					(transferSaleDate === "" && !transferOwnerDidNotSellProperty) ||
					error
				}
				type="submit">
				Continue
			</ButtonV2>
			{error && (
				<div className="exemptions-survey-general-error-msg">
					<p className="sm terracotta">
						Valid dates must be today or a previous date
					</p>
				</div>
			)}
		</form>
	);
};

export default TransferMoveSaleDate;
